'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// TODO: recode without depending on the shitty bs-switch.
// http://www.bootstrap-switch.org/
/**
 * @param on-change callback quand on change l'état
 */
ngModule.directive('btnOnOff', function ($timeout, $translate) {
  return {
    restrict: 'E',
    replace: true,
    template: '' + '<div class="make-switch switch-small" data-on-label="{{switchOnLabel | translate}}" data-off-label="{{switchOffLabel | translate}}">' + '   <input type="checkbox" ng-model="model" ng-change="change()"/>' + '</div>',
    scope: {
      model: '=',
      switchOnLabel: '@',
      switchOffLabel: '@',
      onChange: '&'
    },
    link: function postLink(scope, element, attrs) {
      var defaultOnLabel = "";
      var defaultOffLabel = "";
      var setDefaults = function setDefaults() {
        if (!scope.model) {
          scope.model = false;
        }
        if (!scope.switchOnLabel) {
          scope.switchOnLabel = defaultOnLabel;
        }
        if (!scope.switchOffLabel) {
          scope.switchOffLabel = defaultOffLabel;
        }
      };
      var listenToModel = function listenToModel() {
        scope.$watch('model', function (newValue) {
          if (newValue !== undefined) {
            element.bootstrapSwitch('setState', newValue || false);
          }
        });
        scope.change = function () {
          if (scope.onChange) {
            scope.onChange();
          }
        };
        scope.$watch('switchOnLabel', function (newValue) {
          element.bootstrapSwitch('setOnLabel', newValue ? $translate(newValue) : "&nbsp;");
        });
        scope.$watch('switchOffLabel', function (newValue) {
          element.bootstrapSwitch('setOffLabel', newValue ? $translate(newValue) : "&nbsp;");
        });
      };
      var listenToView = function listenToView() {
        element.on('switch-change', function (e, data) {
          var value = data.value;
          if (value !== scope.model) {
            scope.$apply(function () {
              scope.model = value;
            });
          }
        });
      };

      // Collect ya garbage - makes angular crash during view removal, do not uncomment.
      /*
       scope.$on('$destroy', function() {
       element.bootstrapSwitch('destroy');
       });
       */

      // Do stuff as soon as possible
      $timeout(function () {
        // Sets the defaults
        setDefaults();

        // Init the switch
        element.bootstrapSwitch();

        // Listen and respond to view changes
        listenToView();

        // Listen and respond to model changes
        listenToModel();
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/form/button/btn-on-off.js
// module id = 2942
// module chunks = 13